import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loading } from "../Other/Loading";
import { useTranslation } from "react-i18next";

const AcademySolutions = () => {
  const [data, setData] = useState(null);
  const { t } = useTranslation();
 
  useEffect(() => {
  const fetchData = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/forbusiness`);
        console.log("=======API Response:========", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("++++++++++++++API Response:++++++++++++++++", events);
        setData(events.featuresSection);  // turns string into array of objects
        console.log("Trusted Data====:", events.featuresSection);
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
  };

  fetchData();
}, [t]);

  // Prevent background scrolling when modal is open
  const scrollToForm = () => {
    const element = document.getElementById("lead-form");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };


  if (!data) return <p><Loading /></p>;

  return (
    <div className="p-6  text-center">
      

      {/* Content Section with Side-by-Side Layout */}
      <div className="mt-14 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8 w-[80%]">

        {/* Text Content on the Left */}
        <div className="md:w-1/2 text-left">
          <h2 className="text-4xl font-bold">{data.heading}</h2>

          {/* Buttons */}
          <div className="mt-6 flex flex-wrap gap-4 w-full">
            {/* Training schedules as a button with a link */}
            <a href="/training-schedules" target="_blank" className="w-full md:w-auto">
              <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full">
                Training schedules
              </button>
            </a>

            {/* Contact Sales Button to Open Modal */}
            <button
              className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-100 w-full md:w-auto"
              onClick={scrollToForm}
            >
              Contact sales
            </button>
          </div>

        </div>

        {/* Academy Solutions Chart Image on the Right */}
        <div className="md:w-1/2 flex justify-center">
          {data.solutionsImage ? (
            <img
              // src={`${process.env.REACT_APP_COURSE_API_BASEURL}${data.solutionsImage}`}
              src={data.solutionsImage} // Use public path directly
              alt="Academy Solutions Chart"
              className="max-w-full h-auto"
            />
          ) : (
            <p className="text-gray-500 mt-4">Chart image not available.</p>
          )}
        </div>
      </div>


    </div>
  );
};

export default AcademySolutions;
